import ImgCourse from '../../img/CourseFlow.jpg'
import styled from 'styled-components';

// 学習の流れ
const WidImg = styled.img`
    width: 80%;
`;  
const Center = styled.div`text-align: center;`;
const MarginWidth = styled.div`
    width: 90%;
    margin: 0 auto;
`;  

const CourseTitle =styled.span`
    padding-left: 10px;
    color: midnightblue;
    font-weight: 700;
`;
const CourseName = styled.span`
    color: darkblue;
    font-weight:bold;
    font-size: 25px;
`;
const CardText = (props) => {
    return (
        <>
            <div className="card w-100 border-0" style={{margin:'0 auto'}}>
                <div className="card-body">
                    <h5 className="card-title">
                        <CourseName>{props.CourseName}</CourseName>
                        <CourseTitle>{props.title}</CourseTitle>
                    </h5>
                    <p className="card-text">
                        {props.text}
                    </p>
                </div>
            </div>
        </>
    );
}
const StudyFlow = () => {
    return(
        <>
        <MarginWidth>
            <Center><WidImg className="mt-5" src={ImgCourse}/></Center>
            
            <p className="text-center"><a href="https://www.tosajuku.com/Course.pdf" target="_black">PDF表示</a></p>
            <CardText  CourseName="YTコース"  title="全国の超難関校に合格できる学力を身につけるコースです。" 
                       text="土佐塾が進学塾大手の四谷大塚とタッグを組み、従来の指導内容、 使用教材および公開組分けテスト等のほかに週例テストも実施し、全国の四谷大塚直営教室と 同じスタイルで授業を受けることができます。県外難関中向けハイレベル特訓教室となっています。"
            />
            {/* <CardText  CourseName="4TSコース"  title="土佐中絶対合格、塾中・学芸中の特待生を目指すコースです。" 
                       text="県内の難関志望校の合格をより確実にするため、 基礎学力と思考力・応用力を身に付けるコースです。授業は算数と国語の2教科を学び、YTコース同様、四谷大塚のカリキュラムで先取り学習を行います。また、5週に1回の公開組分けテストで、全国の中でのお子様の学力を確認します。また、5年時で土佐塾各教室の受験コースへの移籍も可能で、受験コースでは常に最上位の位置となれるようご指導いたします。"
            /> */}
        </MarginWidth>
        </>
    );
}

export default StudyFlow;